import ListItemLinkPerson from './link-card-person-view';

export default ListItemLinkPerson;
